




























import { Component, Vue } from "vue-property-decorator";
import { deleteUserGroup } from "@/services/users/userGroupService";

@Component
export default class UserGroupUserDeleteModal extends Vue {
    itemToBeDeleted: string = "";
    name: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(id: string, name: string) {
        this.itemToBeDeleted = id;
        this.name = name;
        this.$bvModal.show("modal-deleteUserGroupUser");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deleteUserGroupUser");
        this.itemToBeDeleted = "";
        this.name = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        this.$emit("delete", this.itemToBeDeleted);
        this.itemToBeDeleted = "";
        this.name = "";
        this.$bvModal.hide("modal-deleteUserGroupUser");
    }
}
